<template>
  <v-navigation-drawer floating width="280"  app clipped permanent>
    <div class="setting-item" :class="{ active: $route.name == constant.LABELS }" @click="routerTo('/labels')">
      <div  class="pl-8 pr-3"><svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.510126 -0.000125552H7.64757C7.80444 -0.000125552 7.92194 0.0392488 8.00069 0.15675L15.4519 7.60795C16.1575 8.27483 16.1575 9.41163 15.4519 10.118L10.1188 15.4511C9.41314 16.1568 8.27557 16.1568 7.60869 15.4511L0.157486 7.99995C0.0399848 7.92182 0.000610352 7.80369 0.000610352 7.64683V0.50939C0.000610352 0.195646 0.235602 -0.000610352 0.51061 -0.000610352L0.510126 -0.000125552ZM9.64757 11.9218C9.49069 12.118 9.13757 12.118 8.98069 11.9218C8.78443 11.7255 8.78443 11.4118 8.98069 11.2162L11.2157 8.98112C11.412 8.78487 11.7257 8.78487 11.9214 8.98112C12.1176 9.138 12.1176 9.49112 11.9214 9.648L9.64696 11.9224L9.64757 11.9218ZM8.39256 10.6668C8.1963 10.863 7.88256 10.863 7.68693 10.6668C7.49067 10.4705 7.49067 10.1568 7.68693 9.96115L9.96133 7.68675C10.1576 7.4905 10.4713 7.4905 10.667 7.68675C10.8632 7.88301 10.8632 8.19675 10.667 8.39239L8.39256 10.6668ZM3.53 3.52935C4.19688 2.86247 5.29496 2.86247 5.9612 3.52935C6.66683 4.19623 6.66683 5.29431 5.9612 5.96055C5.29432 6.66618 4.19624 6.66618 3.53 5.96055C2.86312 5.29367 2.86312 4.19559 3.53 3.52935ZM4.23563 4.23498C3.96126 4.50935 3.96126 4.97997 4.23563 5.25435C4.51 5.5681 4.98062 5.5681 5.25501 5.25435C5.56875 4.97999 5.56875 4.50936 5.25501 4.23498C4.98064 3.96061 4.51001 3.96061 4.23563 4.23498ZM7.45131 0.979938H0.98075V7.4505L8.31387 14.7836C8.62761 15.058 9.09824 15.058 9.412 14.7836L14.7845 9.41114C15.0588 9.09739 15.0588 8.62677 14.7845 8.31301L7.45131 0.979938Z"
          :fill="$route.name == constant.LABELS ? '#009FE0' : '#7392AE'"
        />
      </svg></div>
      <div>Quản lý nhãn</div>
    </div>
    <div class="setting-item" :class="{ active: $route.name == constant.SETTING }" @click="routerTo('/setting')">
    <div  class="pl-8 pr-3">
          <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 15.0611V0.938876C0.000694397 0.420816 0.420834 0.00069333 0.938876 0H11.5056C12.0236 0.000694397 12.4438 0.420834 12.4445 0.938876V6.78952L11.7334 7.50062V0.938876C11.7327 0.813182 11.6313 0.711801 11.5056 0.711108H0.938876C0.813182 0.711802 0.711801 0.813191 0.711108 0.938876V15.0611C0.711802 15.1868 0.813191 15.2882 0.938876 15.2889H11.5056C11.6313 15.2882 11.7327 15.1868 11.7334 15.0611V12.7785L12.4445 12.0674V15.0611C12.4438 15.5792 12.0236 15.9993 11.5056 16H0.938876C0.420816 15.9993 0.00069333 15.5792 0 15.0611V15.0611ZM10.491 12.7646L15.0458 8.20978L13.6625 6.82854L9.10837 11.3812L10.491 12.7646ZM15.7139 7.5424C16.0951 7.15977 16.0951 6.54102 15.7132 6.15908C15.3313 5.77715 14.7118 5.77715 14.3299 6.15908L14.1146 6.37505L15.4979 7.75837L15.7139 7.5424ZM8.35765 13.6729L9.74238 13.3992C9.83404 13.3819 9.91876 13.3367 9.98474 13.2708L10.0382 13.2173L8.65489 11.834L8.60142 11.8875V11.8882C8.53545 11.9541 8.491 12.0382 8.47364 12.1298L8.20003 13.5145H8.19933C8.191 13.559 8.20489 13.6041 8.23683 13.6361C8.26878 13.6673 8.31391 13.6812 8.35767 13.6729L8.35765 13.6729ZM4.34309 3.25353C4.34309 3.23339 4.33476 3.21326 4.32087 3.19937C4.30629 3.18478 4.28615 3.17645 4.26601 3.17645H2.23971C2.19735 3.17645 2.16263 3.21117 2.16263 3.25353V5.27983C2.16263 5.32219 2.19735 5.35692 2.23971 5.35692H4.26601C4.28615 5.35692 4.30629 5.34858 4.32087 5.334C4.33476 5.32011 4.34309 5.29997 4.34309 5.27983V3.25353ZM10.2819 4.64588H5.243V5.35699H10.2819V4.64588ZM4.34309 6.98685C4.34309 6.96671 4.33476 6.94657 4.32087 6.93268C4.30629 6.9181 4.28615 6.90976 4.26601 6.90976H2.23971C2.19735 6.90976 2.16263 6.94449 2.16263 6.98685V9.01315C2.16263 9.05551 2.19735 9.09023 2.23971 9.09023H4.26601C4.28615 9.09023 4.30629 9.0819 4.32087 9.06731C4.33476 9.05343 4.34309 9.03329 4.34309 9.01315V6.98685ZM10.2819 8.3792H5.243V9.09031H10.2819V8.3792ZM4.26594 10.643H2.23963C2.19727 10.643 2.16255 10.6777 2.16255 10.7201V12.7464C2.16255 12.7888 2.19727 12.8235 2.23963 12.8235H4.26594C4.28608 12.8235 4.30621 12.8151 4.3208 12.8006C4.33469 12.7867 4.34302 12.7665 4.34302 12.7464V10.7201C4.34302 10.7 4.33469 10.6798 4.3208 10.6659C4.30621 10.6513 4.28608 10.643 4.26594 10.643V10.643ZM5.24371 12.8236H7.43748V12.1125H5.243L5.24371 12.8236Z"
          :fill="$route.name == constant.SETTING  ? '#009FE0' : '#7392AE'"
        />
      </svg>
    </div>

     <div>
          Fanpage
     </div>
    </div>
    <div class="setting-item" :class="{ active: $route.name == constant.OTHERSETTING }"  @click="routerTo('/otherSetting')">
        <div  class="pl-8 pr-3">
            <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
            >
                <path
                        d="M14.51 3.13101C14.5011 3.11494 14.4886 3.09887 14.4743 3.08637C14.385 2.99708 14.2404 2.99708 14.1511 3.08637L11.0743 6.16315L9.86179 4.95065L12.9404 1.87208C12.9546 1.8578 12.9654 1.84351 12.9761 1.82744C13.0404 1.71851 13.0046 1.57923 12.8957 1.51494C11.1421 0.479226 8.84572 0.716726 7.33679 2.22387C6.14036 3.4203 5.74393 5.11673 6.14929 6.64173L0.917144 11.8739C0.863573 11.9274 0.867144 12.0149 0.922502 12.0703L3.95286 15.1007C4.00822 15.156 4.0975 15.1596 4.14929 15.106L9.37965 9.87566C10.9064 10.2828 12.6029 9.88815 13.8011 8.68994C15.3082 7.18101 15.5457 4.88458 14.51 3.13101ZM12.8921 7.77923C11.8546 8.81673 10.2975 9.01673 9.06 8.37923L8.90286 8.53637L8.90107 8.53458L4.00822 13.4292L2.59393 12.0149L6.70286 7.90601C6.70286 7.90601 6.70286 7.9078 6.70465 7.9078L7.6475 6.96494C7.01 5.72744 7.21 4.1703 8.2475 3.1328C8.58212 2.79788 8.98508 2.53915 9.42887 2.37427C9.87266 2.20939 10.3468 2.14225 10.8189 2.17744L8.44572 4.54887C8.33853 4.65618 8.27832 4.80166 8.27832 4.95333C8.27832 5.10501 8.33853 5.25049 8.44572 5.3578L10.6689 7.58101C10.7762 7.6882 10.9217 7.74841 11.0734 7.74841C11.2251 7.74841 11.3705 7.6882 11.4779 7.58101L13.8493 5.20958C13.9154 6.13458 13.5921 7.08101 12.8921 7.77923Z"
                        :fill="$route.name == constant.OTHERSETTING ?   '#009FE0' : '#7392AE'"
                />
            </svg>

        </div>
        <div>
            Cài đặt khác
        </div>
    </div>
    <div v-if="checkPermission('bitu-shift-management_read')" class="setting-item" :class="{ active: $route.name == constant.SCHEDULE_MANAGEMENT }"  @click="routerTo('/schedule-management')">
      <div  class="pl-8 pr-3">
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
              d="M14.51 3.13101C14.5011 3.11494 14.4886 3.09887 14.4743 3.08637C14.385 2.99708 14.2404 2.99708 14.1511 3.08637L11.0743 6.16315L9.86179 4.95065L12.9404 1.87208C12.9546 1.8578 12.9654 1.84351 12.9761 1.82744C13.0404 1.71851 13.0046 1.57923 12.8957 1.51494C11.1421 0.479226 8.84572 0.716726 7.33679 2.22387C6.14036 3.4203 5.74393 5.11673 6.14929 6.64173L0.917144 11.8739C0.863573 11.9274 0.867144 12.0149 0.922502 12.0703L3.95286 15.1007C4.00822 15.156 4.0975 15.1596 4.14929 15.106L9.37965 9.87566C10.9064 10.2828 12.6029 9.88815 13.8011 8.68994C15.3082 7.18101 15.5457 4.88458 14.51 3.13101ZM12.8921 7.77923C11.8546 8.81673 10.2975 9.01673 9.06 8.37923L8.90286 8.53637L8.90107 8.53458L4.00822 13.4292L2.59393 12.0149L6.70286 7.90601C6.70286 7.90601 6.70286 7.9078 6.70465 7.9078L7.6475 6.96494C7.01 5.72744 7.21 4.1703 8.2475 3.1328C8.58212 2.79788 8.98508 2.53915 9.42887 2.37427C9.87266 2.20939 10.3468 2.14225 10.8189 2.17744L8.44572 4.54887C8.33853 4.65618 8.27832 4.80166 8.27832 4.95333C8.27832 5.10501 8.33853 5.25049 8.44572 5.3578L10.6689 7.58101C10.7762 7.6882 10.9217 7.74841 11.0734 7.74841C11.2251 7.74841 11.3705 7.6882 11.4779 7.58101L13.8493 5.20958C13.9154 6.13458 13.5921 7.08101 12.8921 7.77923Z"
              :fill="$route.name == constant.OTHERSETTING ?   '#009FE0' : '#7392AE'"
          />
        </svg>

      </div>
      <div>
        Quản lý ca
      </div>
    </div>
    <div v-if="checkPermission('bitu-schedule-management_read')" class="setting-item" :class="{ active: $route.name == constant.WORKSCHEDULEMANAGEMENT }"  @click="routerTo(`${constant.WORKSCHEDULEMANAGEMENT}`)">
        <div  class="pl-8 pr-3 pt-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                <path :fill="$route.name == constant.WORKSCHEDULEMANAGEMENT ?   '#009FE0' : '#7392AE'" d="M6 17c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6m9-9a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3a3 3 0 0 1 3 3M3 5v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2" />
            </svg>
        </div>
        <div>
            Quản lý lịch làm việc
        </div>
    </div>
    <div class="setting-item" :class="{ active: $route.name == constant.REPORT}"  @click="routerTo(`${constant.REPORT}`)">
      <div  class="pl-8 pr-3 pt-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path :fill="$route.name == constant.REPORT ?  '#009FE0' : '#7392AE'" d="M17.45 15.18L22 7.31V21H2V3h2v12.54L9.5 6L16 9.78l4.24-7.33l1.73 1l-5.23 9.05l-6.51-3.75L4.31 19h2.26l4.39-7.56z"/></svg>
      </div>
      <div>
        Báo cáo trực page
      </div>
    </div>
  </v-navigation-drawer>
</template>
<script>
import { constant } from "../../helpers/constant"
export default {
  data() {
    return {
      constant,
      projectTypeEnv: process.env.VUE_APP_NATIONAL_PROJECT_TYPE || null,
    };
  },
  methods: {
    routerTo(to) {
       this.$router.push(to);
    },
  }
};
</script>
<style lang="scss">
.setting-item {
    height: 50px;
    display: flex;
    align-items: center;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    &.active {
       background: #f9fafc;
    border-left: 4px solid #009FE0;
    color: #009FE0;
    font-weight: 700;
    }
}
</style>
